module.exports = __webpack_public_path__ + "01_bob_brown.d8a38c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_bob_brown.png
// module id = tTOO
// module chunks = 0